<template>
  <b-modal
    :id="modalId"
    hide-header
    hide-footer
    centered
    :size="size"
    modal-class="text-input-modal"
    @hidden="onHidden"
    @shown="focusInput"
  >
    <div class="text-input-modal__shell">
      <h2 class="text-input-modal__title">
        {{ title }}
      </h2>
      <input
        ref="input"
        v-model="draft"
        type="text"
        class="text-input-modal__input"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @keydown.enter.prevent="confirm"
      >
      <div class="text-input-modal__actions">
        <button
          type="button"
          class="text-input-modal__btn text-input-modal__btn--cancel"
          @click="close"
        >
          Cancel
        </button>
        <button
          type="button"
          class="text-input-modal__btn text-input-modal__btn--ok"
          :disabled="!draft.trim()"
          @click="confirm"
        >
          OK
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TextInputModal',
  props: {
    modalId: { type: String, required: true },
    title: { type: String, required: true },
    placeholder: { type: String, default: '' },
    maxlength: { type: [String, Number], default: undefined },
    size: { type: String, default: 'sm' },
  },
  data() {
    return {
      draft: '',
    };
  },
  methods: {
    open(value = '') {
      this.draft = value;
      this.$bvModal.show(this.modalId);
    },
    close() {
      this.$bvModal.hide(this.modalId);
    },
    onHidden() {
      this.draft = '';
    },
    focusInput() {
      const el = this.$refs.input;
      if (!el) {
        return;
      }
      el.focus();
      el.select();
    },
    confirm() {
      const value = this.draft.trim();
      if (!value) {
        return;
      }
      this.$emit('save', value);
      this.close();
    },
  },
};
</script>

<style scoped>
.text-input-modal__shell {
  padding: 4px 0;
}

.text-input-modal__title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  color: hsl(222.2, 47.4%, 11.2%);
}

.text-input-modal__input {
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 20px;
  color: hsl(222.2, 47.4%, 11.2%);
  background: hsl(0, 0%, 100%);
  border: 1px solid hsl(214.3, 31.8%, 91.4%);
  border-radius: 4px;
  outline: none;
}

.text-input-modal__input:focus {
  border-color: hsl(162, 73%, 35%);
  box-shadow: 0 0 0 2px hsla(162, 73%, 35%, 0.2);
}

.text-input-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.text-input-modal__btn {
  min-width: 72px;
  padding: 6px 14px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
}

.text-input-modal__btn--cancel {
  color: hsl(222.2, 47.4%, 11.2%);
  background: hsl(0, 0%, 100%);
  border-color: hsl(214.3, 31.8%, 91.4%);
}

.text-input-modal__btn--cancel:hover {
  background: hsl(210, 40%, 96.1%);
}

.text-input-modal__btn--ok {
  color: hsl(0, 0%, 100%);
  background: hsl(162, 73%, 35%);
}

.text-input-modal__btn--ok:hover:not(:disabled) {
  background: hsl(162, 73%, 30%);
}

.text-input-modal__btn--ok:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
